module.exports = __webpack_public_path__ + "img/timeline-face-1.f4f3961a.png";